var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrientNorth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10l5 11.552-.473.448L12 20.105 7.473 22 7 21.552 12 10zm-1.165-7l2.168 2.648V3H14v4.361h-.829l-2.174-2.648v2.648H10V3h.835z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/c68a7e3705be952673638e3e2a889215-orientNorth.svg";
export { SvgOrientNorth as ReactComponent };